"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEAT_TYPE = exports.SEAT_TOP_ICON = exports.SEAT_STYLE = exports.SEAT_STATUS = exports.SEAT_LABEL = exports.SEAT_CENTER_ICON = exports.DEFAULT_SEAT_TYPE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaClassic/theme"));
var _SEAT_STYLE, _SEAT_LABEL;
var SEAT_TYPE = {
  SEAT: 'SEAT',
  HOT_SEAT_FIRST_ROW: 'HOT_SEAT_FIRST_ROW',
  HOT_SEAT: 'HOT_SEAT',
  HOT_SEAT_FRONT_ROWS: 'HOT_SEAT_FRONT_ROWS',
  STANDARD_SEAT_FIRST_ROW: 'STANDARD_SEAT_FIRST_ROW',
  STANDARD_SEAT_FRONT_ROWS: 'STANDARD_SEAT_FRONT_ROWS',
  STANDARD_SEAT: 'STANDARD_SEAT',
  STANDARD_SEAT_LIMITED_RECLINE: 'STANDARD_SEAT_LIMITED_RECLINE'
};
exports.SEAT_TYPE = SEAT_TYPE;
var DEFAULT_SEAT_TYPE = SEAT_TYPE.STANDARD_SEAT;
exports.DEFAULT_SEAT_TYPE = DEFAULT_SEAT_TYPE;
var SEAT_STATUS = {
  AVAILABLE: 'AVAILABLE',
  BLOCKED: 'BLOCKED',
  UNAVAILABLE: 'UNAVAILABLE',
  SELECTED: 'SELECTED'
};
exports.SEAT_STATUS = SEAT_STATUS;
var SEAT_TOP_ICON = {
  BASSINET_ICON: 'BASSINET_ICON'
};
exports.SEAT_TOP_ICON = SEAT_TOP_ICON;
var SEAT_CENTER_ICON = {
  STAR_ICON: 'STAR_ICON',
  VOLUME_OFF_ICON: 'VOLUME_OFF_ICON'
};
exports.SEAT_CENTER_ICON = SEAT_CENTER_ICON;
var SEAT_STYLE = (_SEAT_STYLE = {}, (0, _defineProperty2.default)(_SEAT_STYLE, SEAT_TYPE.HOT_SEAT_FIRST_ROW, {
  backgroundColor: '#FA8A81'
}), (0, _defineProperty2.default)(_SEAT_STYLE, SEAT_TYPE.HOT_SEAT, {
  backgroundColor: _theme.default.colors.primary
}), (0, _defineProperty2.default)(_SEAT_STYLE, SEAT_TYPE.HOT_SEAT_FRONT_ROWS, {
  backgroundColor: '#6C0800' // brown color
}), (0, _defineProperty2.default)(_SEAT_STYLE, SEAT_TYPE.STANDARD_SEAT_FIRST_ROW, {
  backgroundColor: '#003B8D'
}), (0, _defineProperty2.default)(_SEAT_STYLE, SEAT_TYPE.STANDARD_SEAT_FRONT_ROWS, {
  backgroundColor: '#507AB4'
}), (0, _defineProperty2.default)(_SEAT_STYLE, SEAT_TYPE.STANDARD_SEAT, {
  backgroundColor: _theme.default.colors.greyDark
}), (0, _defineProperty2.default)(_SEAT_STYLE, SEAT_TYPE.STANDARD_SEAT_LIMITED_RECLINE, {
  backgroundColor: _theme.default.colors.greyDark
}), _SEAT_STYLE);
exports.SEAT_STYLE = SEAT_STYLE;
var SEAT_LABEL = (_SEAT_LABEL = {}, (0, _defineProperty2.default)(_SEAT_LABEL, SEAT_TYPE.SEAT, 'Seat / Normal'), (0, _defineProperty2.default)(_SEAT_LABEL, SEAT_TYPE.HOT_SEAT_FIRST_ROW, 'Hot seat / First row'), (0, _defineProperty2.default)(_SEAT_LABEL, SEAT_TYPE.HOT_SEAT, 'Hot seat / Normal'), (0, _defineProperty2.default)(_SEAT_LABEL, SEAT_TYPE.HOT_SEAT_FRONT_ROWS, 'Hot seat / Front rows'), (0, _defineProperty2.default)(_SEAT_LABEL, SEAT_TYPE.STANDARD_SEAT_FIRST_ROW, 'Standard seat / First row'), (0, _defineProperty2.default)(_SEAT_LABEL, SEAT_TYPE.STANDARD_SEAT_FRONT_ROWS, 'Standard seat / Front rows'), (0, _defineProperty2.default)(_SEAT_LABEL, SEAT_TYPE.STANDARD_SEAT, 'Standard seat / Normal'), _SEAT_LABEL);
exports.SEAT_LABEL = SEAT_LABEL;